<template>
  <div class="fquestion-ask" :class="{ always_opened: alwaysOpened }">
    <f-fade-transition mode="out-in">
      <ask-question-custom-button class="fquestion-ask-button" type="primary" :color="buttonColor" :text-color="buttonTextColor" @click="$emit('showmodal')"
        v-if="!alwaysOpened && !showModal">
        <f-icon icon="fa6-comment"></f-icon> {{ buttonTitle }}
      </ask-question-custom-button>

      <f-dialog class="fquestion-ask-modal dot_not_close" :title2="'Ask a question' | vtranslate"
        v-if="showModal && mode === 'question'">
        <template #content>
          <f-textfield :input.sync="model.author">
            <template #label>{{ "Author" | vtranslate }}</template>
          </f-textfield>
          <f-textarea :input.sync="model.question">
            <template #label>{{ "Question" | vtranslate }}</template>
          </f-textarea>

          <f-fade-transition>
            <f-info v-if="displayError" icon="fa6-warning" class="error">
              {{ currentError }}
            </f-info>
          </f-fade-transition>
        </template>
        <template #actions>
          <f-button type="teriary" @click="$emit('clearmodal')" v-if="!alwaysOpened">
            {{ "Cancel" | vtranslate }}
          </f-button>
          <ask-question-custom-button type="primary" :color="buttonColor" :text-color="buttonTextColor" @click="$emit('postquestion')">{{
            "Send" | vtranslate
            }}</ask-question-custom-button>
        </template>
      </f-dialog>
      <f-dialog class="fquestion-ask-modal" :title2="'' | vtranslate" v-if="showModal && mode === 'success'">
        <template #content>
          <span class="fquestion-ask-success">
            <f-icon icon="fa6-check"></f-icon>{{ "Question sent sucessfully" | vtranslate }}</span>
        </template>
        <template #actions>
          <ask-question-custom-button type="primary" :color="buttonColor" :text-color="buttonTextColor" @click="$emit('clearmodal')">{{
            "Ok" | vtranslate
            }}</ask-question-custom-button>
        </template>
      </f-dialog>
    </f-fade-transition>
  </div>
</template>

<script>
import { angularInvoke } from "/vodalys/vvuejs";
import AskQuestionCustomButton from "./AskQuestionCustomButton.vue";
export default {
  props: {
    component: Object,
    showModal: Boolean,
    currentError: String,
    displayError: Boolean,
    buttonTitle: String,
    buttonColor: {
      type: String,
      default: '#5cbab6'
    },
    buttonTextColor: {
      type: String,
      default: '#FFF'
    },
    mode: String,
    model: Object,
    alwaysOpened: Boolean,
  },
  components: {
    AskQuestionCustomButton
  },
  filters: {
    vtranslate(data) {
      return angularInvoke(function (vTranslateService) {
        return vTranslateService.translate(data);
      });
    },
  },
};
</script>

<style lang="scss">
.fquestion-ask {
  border: none;
  box-shadow: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  .fquestion-ask-button {
    opacity: 0.6;
    border: none;
    box-shadow: none;

    &:hover {
      opacity: 1;
    }
  }

  &.always_opened {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  &:not(.always_opened) {
    .fquestion-ask-modal {
      position: absolute;
      right: 0;
      border: none;
      box-shadow: none;
    }
  }


  .fquestion-ask-success {
    display: flex;
    flex-direction: row;
    gap: 8px;
    border: none;
    box-shadow: none;
  }

  .fquestion-ask-modal {
    border: none;
    box-shadow: none;
    width: 100%;
    height: 100%;
  }

  .fquestion-ask-modal .f-dialog__content {
    width: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    padding: 16px;
  }

  .f-dialog.fquestion-ask-modal  {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .f-dialog-content {
      margin: 0;
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      justify-content: stretch;

      .f-textarea {
        flex-grow: 1;

        display: flex;
        flex-direction: column;

        >.f-center {
          flex-grow: 1;

          >* {
            height: 100%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .fquestion-ask-modal {
    zoom: 0.6;
  }
}
</style>